import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  VENUE_CATEGORIES_ADD_PATH,
  VENUE_CATEGORIES_PATH,
  VENUE_CATEGORIES_UPDATE_PATH,
} from "utils/constants/paths";

const VenueCategories = Loadable(React.lazy(() => import("./View")));
const VenueCategoriesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const VenueCategoriesRoute: IRouteItem = {
  path: VENUE_CATEGORIES_PATH,
  iconName: "Category",
  element: React.createElement(VenueCategories),
  name: "Venue Categories",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
  children: [
    {
      name: "Add / Update",
      path: VENUE_CATEGORIES_ADD_PATH,
      element: React.createElement(VenueCategoriesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: VENUE_CATEGORIES_UPDATE_PATH,
      element: React.createElement(VenueCategoriesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
